import PreviewImageSelect from 'components/select/PreviewImageSelect';
import HorizontalTable from 'components/table/HorizontalTable';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 *
 * @returns {운영 - 프로모션 다국어 폼}
 */
const LocalizingInputPromotion = ({
  langData,
  setLangData,
  bannerDropList,
}) => {
  const { t } = useTranslation();
  /// 이미지 셀렉트 이벤트
  const handleImgChange = (val, ob) => {
    setLangData(
      langData?.map((v) =>
        v.lang === ob.title ? { ...v, [ob.name]: val } : v,
      ),
    );
  };
  return (
    <>
      <HorizontalTable>
        <>
          <thead>
            <tr>
              <th className='code_name_th'>
                {t('promotion.promotionInputModal.multilingual')}
              </th>
              <th>{t('promotion.promotionInputModal.promotionBanner')}</th>
            </tr>
          </thead>
          <tbody>
            {langData?.map((v, i) => (
              <tr key={i}>
                <td className='code_name_td'>
                  {t(`dbLngList.${i}.code_name`)}
                </td>
                <td className='image_td'>
                  <PreviewImageSelect
                    name='design_id'
                    imgUrl={v.image_url}
                    title={v.lang}
                    value={v.design_id}
                    optionList={bannerDropList}
                    onChange={handleImgChange}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </>
      </HorizontalTable>
    </>
  );
};

export default LocalizingInputPromotion;
